<template>
  <div class="overflow-auto">
    <b-pagination
      v-on:input="setCurrentPage($event)"
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      aria-controls="items-list"
      pills 
      align="center"
    ></b-pagination>

    <!-- <p class="mt-3">Current Page: {{ currentPage }}</p> -->

  </div>
</template>

<script>
  export default {
    data() {
      return {
        perPage: 1,
        currentPage: 1
      }
    },
    computed: {
      rows() {
        return this.$store.getters['inventario/getTotalPages']
      }
    },
    methods: {
      setCurrentPage (newPage) {
        this.$store.commit('inventario/setCurrentPage', { page: newPage })
        const data = {
            nr_seq_inventario: this.$route.params.id
        }

        this.$store.dispatch('inventario/getItensInventario', { data: data })
      }

    }
  }
</script>